import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/scrolltotop/ScrollToTop';
import HomeFour from './pages/homepages/HomeFour';
import AboutUsOne from './pages/innerpages/AboutUsOne';
import BlogGridOne from './pages/blog/BlogGridOne';
import BlogDetailsOne from './pages/detailspages/BlogDetailsOne';
import ContactUs from './pages/innerpages/ContactUs';
import CourseOne from './pages/course/CourseOne';
import Error from './pages/innerpages/Error';

// Import Css Here
import './assets/scss/style.scss';

function App() {
    return (
        <Router>
            <ScrollToTop>
                <Routes>
                    <Route exact path='/' element={<HomeFour/>}/>
                    <Route exact path='/about-us-1' element={<AboutUsOne/>}/>
                    <Route exact path='/course-1' element={<CourseOne/>}/>
                    <Route exact path='/blog-grid-1' element={<BlogGridOne/>}/>
                    <Route exact path='/blog-details/:id' element={<BlogDetailsOne/>}/>
                    <Route exact path='/contact-us' element={<ContactUs/>}/>
                    <Route path='*' element={<Error/>}/>
                </Routes>
            </ScrollToTop>
        </Router>
    );
}

export default App;
